import httpClient from './httpClient';
import ErrorModel from './models/ErrorModel';

/**
 * Mint a one-time login token for the current authenticated partner.
 *
 * The BE reads the partner session from `x-partner-token` (attached by the
 * shared httpClient's request interceptor) and returns a short-lived OTL
 * token. That token is then handed off to the new Partners Dashboard,
 * which exchanges it via `/market/partner-login-by-otl` to bootstrap its
 * own session — mirrors the same handshake the new PD uses in reverse.
 */
export interface PartnerOtlResponse {
  token: string;
}

export const generatePartnerOtl = async (): Promise<PartnerOtlResponse | ErrorModel> => {
  // The response interceptor unwraps `res.data` before it reaches this
  // callback, so the runtime value is the raw JSON body. Axios's return
  // type is `AxiosResponse<any>` though, so we type the callback arg as
  // `any` to match the rest of the repo's api/* wrappers (login.ts,
  // register.ts, ...) instead of double-casting through `unknown`.
  return httpClient
    .post('/market/partner-otl')
    .then((response: any) => ({ token: response?.token } as PartnerOtlResponse))
    .catch((error) => error);
};
